import { Button, Card, Form, notification, Tooltip } from 'antd'
import React, { Component } from 'react'
import ReactHtmlParser from 'react-html-parser'
import { connect } from 'react-redux'
import { TableComp } from 'sz-react-utils-lite'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import {
  chooseEmailModalFxn,
  DisplayDate
} from '../../../../components/_utils/appUtils'
import Request, { API_URL } from '../../../../request'
import AbstractActivityList from '../AbstractActivityList'
// import { SendTemplateEmail } from '../../email/actions'
import { getAllAbstracts } from '../actions'
import AbstractFilters from '../../views/abstractPages/AbstractFilters'
// import CompletePublishAbstractDrawer from '../drawers/CompletePublishAbstractDrawer'

@Form.create()
class OnlinePublishAbstract extends Component {
  state = {
    filters: {},
    visibleDrawer: false,
    abstract: {}, // Changed from article
    total: '',
    visibleActivityList: false
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      let { dispatch } = this.props
      let obj = {
        ...params,
        ...this.state.filters,
        status: 'Online Publish'
      }
      let regExpFilters = []

      // Using abstract action
      let data = await dispatch(
        getAllAbstracts({ ...obj, regExFilters: regExpFilters })
      )

      this.setState({ total: data.total })
      resolve(data)
    })
  }

  reload = () => {
    this.table.current.reload()
  }

  reloadTable = data => {
    if (data.fromDate && data.toDate) {
      data['createdAt'] = {
        $gte: data.fromDate,
        $lte: data.toDate
      }
      delete data['fromDate']
      delete data['toDate']
    }
    this.setState({ filters: data }, () => {
      this.reload()
    })
  }

  // Assuming you have a deleteAbstract request
  // deleteAbstract = async data => {
  //   let resp = await Request.deleteAbstract(data)
  //   this.reload()
  // }

  // sendMailFxn = record => {
  //   let { dispatch } = this.props
  //   chooseEmailModalFxn({
  //     callback: async email => {
  //       let obj = {
  //         abstractId: record._id, // Changed to abstractId
  //         fromEmail: email,
  //         emailType: 'acknowledgement',
  //         template:
  //           record.publicationCharges > 0 // Abstracts use publicationCharges
  //             ? 'acknowledgementWithCharges'
  //             : 'acknowledgementWithoutCharges',
  //         type: 'abstract' // Changed to abstract
  //       }
  //       let resp = await dispatch(
  //         SendTemplateEmail({
  //           email,
  //           id: record._id,
  //           obj,
  //           template: obj.template
  //         })
  //       )
  //       if (resp && resp.success) {
  //         notification.success({
  //           message: resp.message
  //         })
  //         this.reload()
  //       }
  //     }
  //   })
  // }

  render() {
    const columns = [
      {
        key: 'actions',
        title: 'Abstract No',
        width: '85px',
        render: (val, record) => (
          <Tooltip title="View Details">
            <a href={`/abstract/view/${record._id}`}>
              {record.abstractNo || record.onlineAbstractId}
            </a>
          </Tooltip>
        )
      },
      {
        title: 'Submitted Date',
        key: 'createdAt',
        dataIndex: 'createdAt',
        width: 100,
        render: item => {
          return item ? DisplayDate(item) : null
        }
      },
      {
        title: 'Abstract Title',
        key: 'titleOfAbstract',
        render: (item, record) => {
          let title = item ? item : record.titleOfAbstract;
          return title ? ReactHtmlParser(title) : null
        }
      },
      {
        title: 'Country',
        key: 'country',
        dataIndex: 'country'
      },
      {
        title: 'Author',
        key: 'authorName',
        dataIndex: 'authorName'
      },
      {
        title: 'Email',
        key: 'email',
        dataIndex: 'email'
      },
      {
        title: 'Acceptance Date',
        key: 'approvedAbstractPaymentDate', // Based on your previous abstract setup
        width: 100,
        render: item => {
          return item ? DisplayDate(item) : null
        }
      },
      {
        title: 'DOI Date',
        key: 'doiProcessDate',
        width: 100,
        render: item => {
          return item ? DisplayDate(item) : null
        }
      },
      {
        title: 'Online Publish Date',
        key: 'onlinePublishedDate',
        dataIndex: 'onlinePublishedDate',
        width: 100,
        render: item => {
          return item ? DisplayDate(item) : null
        }
      },
      {
        title: 'Action',
        key: 'Action',
        render: (item, record) => {
          return (
            <>
              {/*<Button*/}
              {/*  className={'roundSmallBtn'}*/}
              {/*  onClick={() =>*/}
              {/*    this.setState({ visibleDrawer: true, abstract: record })*/}
              {/*  }>*/}
              {/*  Complete Publication*/}
              {/*</Button>*/}
              <Button
                className={'roundSmallBtn'}
                onClick={() =>
                  this.setState({ visibleActivityList: true, abstract: record })
                }>
                Abstract Activities
              </Button>
            </>
          )
        }
      }
    ]

    return (
      <PageHeaderWrapper
        title={`Online Publish Abstracts (${this.state.total})`}>
        <Card bordered={true}>
          <AbstractFilters
            callback={data => {
              this.reloadTable(data)
            }}
          />
          <TableComp
            ref={this.table}
            columns={columns}
            apiRequest={this.apiRequest}
          />
        </Card>

        {/* NOTE: You will need to create CompletePublishAbstractDrawer */}
        {/*{this.state.visibleDrawer ? (*/}
        {/*  <CompletePublishAbstractDrawer*/}
        {/*    visible={this.state.visibleDrawer}*/}
        {/*    abstractId={this.state.abstract._id}*/}
        {/*    abstract={this.state.abstract}*/}
        {/*    Id={this.state.abstract._id}*/}
        {/*    callback={this.reload}*/}
        {/*    edit={false}*/}
        {/*    onClose={() => this.setState({ visibleDrawer: false })}*/}
        {/*  />*/}
        {/*) : null}*/}

        {this.state.visibleActivityList ? (
          <AbstractActivityList
            abstractId={this.state.abstract._id}
            abstractNo={this.state.abstract.abstractNo || this.state.abstract.onlineAbstractId}
            visible={this.state.visibleActivityList}
            onClose={() => this.setState({ visibleActivityList: false })}
          />
        ) : null}
      </PageHeaderWrapper>
    )
  }
}

const mapStateToProps = ({ global }) => ({
  categories: global.categories
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OnlinePublishAbstract)